// Function loadPageFilter loads the PageFilter class by dynamically importing the js on demand if needed

export function loadPageFilter($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="PageFilter"]');

	if(!$wg) {
		// console.info('PageFilter: no widget found');
		return Promise.reject('PageFilter widget not found in the parent element');

	}

	return import(/* webpackChunkName: "wg-page-filter-chunk" */ '../widgets/pageFilter').then(wg => {

		const { PageFilter } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="PageFilter"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new PageFilter($wg) );
				if (instances.length === $wgCol.length) return instances;
			});

		} else {
			return new PageFilter($wg);
		}


	}).catch(error => error+'An error occurred while loading the PageFilter widget');

}
